// React
import React, { useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Spin } from 'antd';
import MenuState from './Container';
/**
 * @description 页面不存在
 */
const NotExist = () => {
    const location = useLocation();
    const container = MenuState.useContainer();
    const isExist = useCallback(() => {
        const routers = container.flatOriginRouter;
        return Object.keys(routers).includes(location.pathname);
    }, [location.pathname, container.flatOriginRouter]);

    return (
        <div className="not-exist-permission--content-page">
            {isExist() ? (
                <>
                    {container.noPermission ? (
                        container.noPermission
                    ) : (
                        <>
                            <img
                                src="https://simg01.gaodunwangxiao.com/uploadimgs/goodsCenter/202009/28/3f26d_20200928112322.jpg"
                                alt=""
                                className="bg" />
                            <div className="not-exist-info">
                                <h3>401</h3>
                                <p>
                                    您没有权限！
                                    <Link to="/">返回首页</Link>
                                </p>
                            </div>
                        </>
                    )}
                </>
            ) : (
                <>
                    {container.notExist ? (
                        container.notExist
                    ) : (
                        <>
                            <img
                                src="https://simg01.gaodunwangxiao.com/uploadimgs/goodsCenter/202009/28/3f26d_20200928112322.jpg"
                                alt=""
                                className="bg" />
                            <div className="not-exist-info">
                                {container.loading ? (
                                    <Spin>加载中</Spin>
                                ) : (
                                    <>
                                        <h3>404</h3>
                                        <p>
                                            页面不存在！
                                            <Link to="/">返回首页</Link>
                                        </p>
                                    </>
                                )}
                            </div>
                        </>
                    )}
                </>
            )}
        </div>
    );
};

export default NotExist;
